export default "__VITE_PUBLIC_ASSET__4b79dff0__"